import cs from './const.js';
import AntString from './AntString.js';
// import AntLocalStorage from './AntLocalStorage.js';
import AntTime from './AntTime';
import moment from 'moment-timezone';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import stringify from './stableStringify';
import hash from 'hash-sum';
import { applySessionSnapshot, createSessionSnapshotRequest } from './AntSessionSnapshotTransport';
import { resolveServiceRoutingHeaders } from './AntServiceRouting';

let lastSessionCheck = {
    token: null,
    socketToken: null,
    info: null,
    checksum: null,
    result: false
};

export default {
    register(obj, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        sessionStorage.clear();
        localStorage.clear();
        localStorage.setItem(cs.System_Code + '-Sys_BaseURL', String(BaseURL));

        var URL = '/user/ACUserAuthen/register';
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;
        var queryURL = AntString.clean(BaseURL + URL);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        };

        var that = this;
        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(stringify(obj)),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    },

    isValidSession() {
        if (!AntTime.isValidLicenseTime()) {
            console.log('Your License is expired! Please contact to trung.dao@ante.vn');
            return false;
        }

        if (!cs.Login_Required) return true;

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        const socketToken = localStorage.getItem(cs.System_Code + '-session-socketToken');
        const info = localStorage.getItem(cs.System_Code + '-session-info');
        const checksum = localStorage.getItem(cs.System_Code + '-session-checksum');

        if (!token || !info || !socketToken || !checksum) return false;

        if (
            token === lastSessionCheck.token &&
            socketToken === lastSessionCheck.socketToken &&
            info === lastSessionCheck.info &&
            checksum === lastSessionCheck.checksum
        ) {
            return lastSessionCheck.result;
        }

        try {
            var hashKey = hash(
                AntString.clean(
                    stringify({
                        token: String(token),
                        socketToken: String(socketToken)
                    })
                )
            );
            // Tương thích checksum cũ trong localStorage ở lần chạy đầu sau nâng cấp.
            // Các lần save mới chỉ hash hai token, đồng nhất POS/mobile và không còn
            // stringify toàn bộ settings chỉ để kiểm tra tính toàn vẹn cục bộ.
            const result = checksum === hashKey || checksum === hash(
                AntString.clean(stringify({
                    token: String(token),
                    socketToken: String(socketToken),
                    info: JSON.parse(info)
                }))
            );
            lastSessionCheck = { token, socketToken, info, checksum, result };
            return result;
        } catch (error) {
            // console.log('ant-log-isValidSession-error-info=', info);
            return false;
        }
    },

    checkValidSession() {
        var isValid = this.isValidSession();
        if (!isValid) {
            console.log('ant-log-LOGOUT-checkValidSession : ');
            this.logOut();
        }
    },

    resetPassword(body, cb) {
        var URL = '/user/ACUserAuthen/resetPassword';

        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        let info = {};
        try { info = JSON.parse(localStorage.getItem(cs.System_Code + '-session-info')) || {}; } catch (e) { /* ignore */ }

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
            'Business-Short-Code': info.business_short_code || '',
            'Business-Zone-Code': info.business_zone_code || '',
            'Business-Industry': info.business_industry || '',
            'Business-Sub-Industry': info.business_sub_industry || '',
            ...resolveServiceRoutingHeaders(info)
        };

        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(stringify(body)),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                // if (
                //     data?.code == cs.erAuthenticationFailed.code ||
                //     data?.code == cs.erAccountIsLocked.code ||
                //     data?.code == cs.erLoggedInOtherDevice.code
                // ) {
                //     this.logOut();
                //     return;
                // }

                if (data.data && data.data.session) this.saveSessionData(data.data.session, true);

                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    },
    async getDeviceID() {
        const info = localStorage.getItem(cs.System_Code + '-session-info');
        if (!info) return;

        // console.log('ant-log-info : ', JSON.parse(info));
        return JSON.parse(info).device_id;
        // const fp = await FingerprintJS.load();
        // const result = await fp.get();
        // return result.visitorId;
    },

    async logIn(obj, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        // Chưa có phiên nên server không biết ngôn ngữ của người dùng: gửi ngôn ngữ đang chọn (lấy trước
        // khi xoá bộ nhớ) để câu báo sai mật khẩu, tạm khoá... về đúng ngôn ngữ đó.
        var language = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage');
        if (!language || language === 'null' || language === 'undefined') language = '';
        if (language && !obj.Sys_BaseLanguage) obj = { ...obj, Sys_BaseLanguage: language };
        sessionStorage.clear();
        localStorage.clear();
        localStorage.setItem(cs.System_Code + '-Sys_BaseURL', String(BaseURL));
        // Giữ ngôn ngữ đã chọn: đăng nhập sai thì màn đăng nhập vẫn ở đúng ngôn ngữ đó.
        if (language) localStorage.setItem(cs.System_Code + '-Sys_BaseLanguage', language);

        var URL = '/user/ACUserAuthen/login';

        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        // console.log('ant-log-queryURL : ',queryURL);
        // queryURL = 'http://192.168.1.20:80/user/ACUserAuthen/login';

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            ...(language ? { 'Business-Language': language } : {})
        };

        var that = this;
        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(stringify({ ...obj, timezone: moment.tz.guess() })),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                if (cb) cb(data);

                if (data && (data.code == cs.erAuthenticationFailed.code || data.code == cs.erAccountIsLocked.code)) {
                    // that.logOut();
                    return;
                }

                if (data.data && data.data.session) that.saveSessionData(data.data.session, true);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    },

    isSessionExpirable() {
        return true;

        let info = localStorage.getItem(cs.System_Code + '-session-info');
        if (!info) return false;

        info = JSON.parse(info);

        let sessionExpirable = info.user_session_expirable;

        return Boolean(sessionExpirable === undefined || sessionExpirable === null || Boolean(sessionExpirable));
    },

    verifyResponse(data) {
        // Lỗi hạn mức (133 chạm trần, 135 đang tạm khoá ghi): layout hiện nút xem gói dịch vụ cho admin.
        if ((data?.code == cs.erOverQuotaLimit.code || data?.code == cs.erServiceQuotaLocked.code) && typeof window !== 'undefined') {
            try {
                window.dispatchEvent(new CustomEvent('ant-service-quota-error', { detail: data }));
            } catch (e) {
                /* trình duyệt không có CustomEvent */
            }
        }
        if (data?.code == cs.erAuthenticationFailed.code || data?.code == cs.erAccountIsLocked.code || data?.code == cs.erLoggedInOtherDevice.code) {
            if (cs.Login_Required) {
                let sessionExpirable = this.isSessionExpirable();
                if (!sessionExpirable) {
                    return;
                }

                // if (!sessionExpirable && data?.code == cs.erAuthenticationFailed.code) {
                //     return;
                // }

                console.log('ant-log-verifyResponse-logOut : ');
                this.logOut();
            }
        }
    },

    logOut() {
        sessionStorage.clear();
        localStorage.clear();

        window.location.reload();

        if ('caches' in window) {
            caches.keys().then(function (cacheNames) {
                // console.log('ant-log-cacheNames : ',cacheNames);
                return Promise.all(
                    cacheNames.map(function (cacheName) {
                        return caches.delete(cacheName);
                    })
                );
            });
        }
    },

    saveSessionData(session, reload, onChanged, preserveSnapshotState) {
        if (!session || !session.token) return;

        if (!preserveSnapshotState) this.saveSessionSnapshotState(null);

        // sessionStorage.clear();
        // localStorage.clear();
        var token = session.token;
        var socketToken = session.socketToken;
        var info = session.info;

        var oldInfo = localStorage.getItem(cs.System_Code + '-session-info');
        if (oldInfo) oldInfo = JSON.parse(oldInfo);

        var checksum = hash(
            AntString.clean(
                stringify({
                    token: token,
                    socketToken: socketToken
                })
            )
        );

        // localStorage.removeItem(cs.System_Code + '-session-token');
        // localStorage.removeItem(cs.System_Code + '-session-info');
        // localStorage.removeItem(cs.System_Code + '-session-checksum');

        localStorage.setItem(cs.System_Code + '-session-token', String(token));
        localStorage.setItem(cs.System_Code + '-session-socketToken', String(socketToken));
        localStorage.setItem(cs.System_Code + '-session-info', stringify(info));
        localStorage.setItem(cs.System_Code + '-session-checksum', checksum);

        let Sys_BaseURL = info?.bus_settings?.Sys_BaseURL;
        let Sys_BaseCurrency = info?.bus_settings?.Sys_BaseCurrency;
        let Sys_BaseCountry = info?.bus_settings?.Sys_BaseCountry;
        let Sys_BaseCurrency_Show_Symbol = info?.bus_settings?.Sys_BaseCurrency_Show_Symbol;
        let Sys_BaseLanguage = info?.bus_settings?.Sys_BaseLanguage;
        if (!Sys_BaseCurrency_Show_Symbol) Sys_BaseCurrency_Show_Symbol = 0;

        if (Sys_BaseURL) localStorage.setItem(cs.System_Code + '-Sys_BaseURL', Sys_BaseURL);
        localStorage.setItem(cs.System_Code + '-Sys_BaseCurrency', Sys_BaseCurrency);
        // Số lẻ KHÔNG lưu nữa — nó là giá trị dẫn xuất từ đồng tiền và quốc gia,
        // giải lại mỗi lần dùng ở AntLocalization.getCurrencyDecimalDigit.
        localStorage.setItem(cs.System_Code + '-Sys_BaseCountry', Sys_BaseCountry);
        localStorage.setItem(cs.System_Code + '-Sys_BaseCurrency_Show_Symbol', Sys_BaseCurrency_Show_Symbol);
        localStorage.setItem(cs.System_Code + '-Sys_BaseLanguage', Sys_BaseLanguage);

        if (reload) {
            // setTimeout(() => {
            //     window.location.reload();
            // }, 1000 * 3);

            if (onChanged) onChanged(String(token));
            else window.location.reload();
        }

        if (
            oldInfo &&
            info &&
            ((info.bus_settings && oldInfo.bus_settings && stringify(info.bus_settings) !== stringify(oldInfo.bus_settings)) ||
                (info.user_settings && oldInfo.user_settings && stringify(info.user_settings) !== stringify(oldInfo.user_settings)) ||
                stringify({ ...info, bus_settings: undefined, user_settings: undefined }) !==
                stringify({ ...oldInfo, bus_settings: undefined, user_settings: undefined }))
        ) {
            if (onChanged) onChanged(String(token));
            else window.location.reload();
        }
    },

    getSessionSnapshotState() {
        const raw = localStorage.getItem(cs.System_Code + '-session-snapshot');
        if (!raw) return null;
        try {
            return JSON.parse(raw);
        } catch (_error) {
            return null;
        }
    },

    saveSessionSnapshotState(state) {
        const key = cs.System_Code + '-session-snapshot';
        if (!state) {
            localStorage.removeItem(key);
            return;
        }
        localStorage.setItem(key, stringify(state));
    },

    saveRefreshedSessionTokens(session) {
        if (!session || !session.token || !session.socketToken) return false;
        if (!localStorage.getItem(cs.System_Code + '-session-info')) return false;
        const token = String(session.token);
        const socketToken = String(session.socketToken);
        const checksum = hash(AntString.clean(stringify({ token, socketToken })));
        localStorage.setItem(cs.System_Code + '-session-token', token);
        localStorage.setItem(cs.System_Code + '-session-socketToken', socketToken);
        localStorage.setItem(cs.System_Code + '-session-checksum', checksum);
        return true;
    },

    getSessionInfo(fieldName) {
        var info = localStorage.getItem(cs.System_Code + '-session-info');
        if (!info) return {};

        try {
            info = JSON.parse(info);
        } catch (error) {
            // console.log('ant-log-error-info=', info);
            return {};
        }
        if (!fieldName) return info;

        if (info && info[fieldName] !== undefined) return info[fieldName];
    },

    getSessionToken() {
        return localStorage.getItem(cs.System_Code + '-session-token');
    },

    getSessionSocketToken() {
        return localStorage.getItem(cs.System_Code + '-session-socketToken');
    },

    autoRefreshToken(onChanged) {
        this.refreshToken(false, null, null, onChanged);
        // Giữ nhịp 1 phút vì refreshToken còn cập nhật giới hạn giờ truy cập.
        // Snapshot làm response định kỳ nhỏ mà không làm chậm hiệu lực restriction.
        return setInterval(this.refreshToken, 1000 * 60 * 1, false, this, null, onChanged);
    },

    getViewMode() {
        let uiData = this.getUIStates();

        let showMode = uiData?.mode === 'POSUI' ? 'POS' : 'Web';

        let isPOSOnly = this.getDisplayMode() === 'POS_ONLY';

        if (uiData) {
            var userGroupCode = this.getSessionInfo('user_group_code');
            if (userGroupCode === 'Admin') isPOSOnly = false;
        }

        if (isPOSOnly) showMode = 'POS';

        // Nhóm "Chỉ Kế toán" luôn ở không gian Kế toán (thuộc giao diện Web), không vào Máy bán hàng.
        if (this.isAccountingOnly()) showMode = 'Web';

        return showMode;
    },

    getUIStates() {
        try {
            const raw = localStorage.getItem(cs.System_Code + '-ui-states');
            return raw ? JSON.parse(raw) : null;
        } catch (error) {
            return null;
        }
    },

    // Chế độ làm việc của nhóm quyền (setting nhóm UI_display_mode): OPERATION | POS_ONLY | ACCOUNTING_FIRST | ACCOUNTING_ONLY.
    getDisplayMode() {
        const userSettings = this.getSessionInfo('user_settings') || {};
        return userSettings.UI_display_mode;
    },

    // Được vào không gian Kế toán: BE đã tính màn AccountingWorkspace vào access_screens (gói Sổ cái + quyền hoặc Admin).
    canUseAccountingMode() {
        const userSettings = this.getSessionInfo('user_settings') || {};
        return Array.isArray(userSettings.access_screens) && userSettings.access_screens.includes('AccountingWorkspace');
    },

    // Nhóm "Chỉ Kế toán" (Admin không bao giờ bị khóa).
    isAccountingOnly() {
        if (this.getDisplayMode() !== 'ACCOUNTING_ONLY') return false;
        if (this.getSessionInfo('user_group_code') === 'Admin') return false;
        return this.canUseAccountingMode();
    },

    // Không gian đang dùng ở web: 'Accounting' | 'Operation'. Chỉ ở FE (ui-states.mode = 'ACCUI' | 'WebUI' | 'POSUI'),
    // BE không biết chế độ; quyền vẫn kiểm theo từng màn/API.
    getWorkspaceMode() {
        if (this.getViewMode() === 'POS') return 'Operation';
        if (!this.canUseAccountingMode()) return 'Operation';
        if (this.isAccountingOnly()) return 'Accounting';
        const mode = this.getUIStates()?.mode;
        if (mode === 'ACCUI') return 'Accounting';
        if (mode === 'WebUI' || mode === 'POSUI') return 'Operation';
        return this.getDisplayMode() === 'ACCOUNTING_FIRST' ? 'Accounting' : 'Operation';
    },

    // Bị giữ ở một không gian, không hiện nút chuyển chế độ.
    isWorkspaceModeLocked() {
        return this.isAccountingOnly();
    },

    switchStore(storeCode, done) {
        var that = this;

        var URL = '/user/ACUserAuthen/switchStore';

        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        let info = localStorage.getItem(cs.System_Code + '-session-info');
        info = JSON.parse(info);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
            'Business-Short-Code': info.business_short_code,
            'Business-Zone-Code': info.business_zone_code,
            'Business-Industry': info.business_industry,
            'Business-Sub-Industry': info.business_sub_industry,
            ...resolveServiceRoutingHeaders(info)
        };

        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(
                stringify({
                    store_code: storeCode
                })
            ),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                // if (data && (data.code == cs.erAuthenticationFailed.code || data.code == cs.erInvalidRequest.code)) {
                if (
                    data?.code == cs.erAuthenticationFailed.code ||
                    data?.code == cs.erAccountIsLocked.code ||
                    data?.code == cs.erLoggedInOtherDevice.code
                ) {
                    let sessionExpirable = that.isSessionExpirable();
                    if (!sessionExpirable) {
                        if (done) done();
                        return;
                    }

                    that.logOut();
                    if (done) done();
                    return;
                }

                // console.log('ant-log-data.data.session : ',data.data.session);
                if (data.data && data.data.session) that.saveSessionData(data.data.session, true);

                if (done) done();
            })
            .catch((er) => {
                console.log('ant-log-er=', er);
                if (done) done();
            });
    },

    checkinEmployee(empCode, passCode, data, done) {
        var that = this;

        var URL = '/user/ACUserAuthen/verifyEmployeeCheckinPasscode';

        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        let info = localStorage.getItem(cs.System_Code + '-session-info');
        info = JSON.parse(info);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
            'Business-Short-Code': info.business_short_code,
            'Business-Zone-Code': info.business_zone_code,
            'Business-Industry': info.business_industry,
            'Business-Sub-Industry': info.business_sub_industry,
            ...resolveServiceRoutingHeaders(info)
        };

        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(stringify({ ...data, employee_code: empCode, pass_code: passCode })),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                // if (data && (data.code == cs.erAuthenticationFailed.code || data.code == cs.erInvalidRequest.code)) {
                if (
                    data?.code == cs.erAuthenticationFailed.code ||
                    data?.code == cs.erAccountIsLocked.code ||
                    data?.code == cs.erLoggedInOtherDevice.code
                ) {
                    let sessionExpirable = that.isSessionExpirable();
                    if (!sessionExpirable) {
                        if (done) done();
                        return;
                    }

                    that.logOut();
                    if (done) done();
                    return;
                }

                if (data.data && data.data.session) that.saveSessionData(data.data.session, true);

                if (done) done(data);
            })
            .catch((er) => {
                console.log('ant-log-er=', er);
                if (done) done();
            });
    },

    checkoutEmployee(passCode, data, done) {
        var that = this;

        var URL = '/user/ACUserAuthen/verifyEmployeeCheckoutPasscode';

        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        let info = localStorage.getItem(cs.System_Code + '-session-info');
        info = JSON.parse(info);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
            'Business-Short-Code': info.business_short_code,
            'Business-Zone-Code': info.business_zone_code,
            'Business-Industry': info.business_industry,
            'Business-Sub-Industry': info.business_sub_industry,
            ...resolveServiceRoutingHeaders(info)
        };

        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(stringify({ ...data, pass_code: passCode })),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                // if (data && (data.code == cs.erAuthenticationFailed.code || data.code == cs.erInvalidRequest.code)) {
                if (
                    data?.code == cs.erAuthenticationFailed.code ||
                    data?.code == cs.erAccountIsLocked.code ||
                    data?.code == cs.erLoggedInOtherDevice.code
                ) {
                    let sessionExpirable = that.isSessionExpirable();
                    if (!sessionExpirable) {
                        if (done) done();
                        return;
                    }

                    that.logOut();
                    if (done) done();
                    return;
                }

                if (data.data && data.data.session) that.saveSessionData(data.data.session, true);

                if (done) done(data);
            })
            .catch((er) => {
                console.log('ant-log-er=', er);
                if (done) done();
            });
    },

    switchEmployee(empCode, done) {
        var that = this;

        var URL = '/user/ACUserAuthen/switchEmployee';

        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        let info = localStorage.getItem(cs.System_Code + '-session-info');
        info = JSON.parse(info);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
            'Business-Short-Code': info.business_short_code,
            'Business-Zone-Code': info.business_zone_code,
            'Business-Industry': info.business_industry,
            'Business-Sub-Industry': info.business_sub_industry,
            ...resolveServiceRoutingHeaders(info)
        };

        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(
                stringify({
                    employee_code: empCode
                })
            ),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                // if (data && (data.code == cs.erAuthenticationFailed.code || data.code == cs.erInvalidRequest.code)) {
                if (
                    data?.code == cs.erAuthenticationFailed.code ||
                    data?.code == cs.erAccountIsLocked.code ||
                    data?.code == cs.erLoggedInOtherDevice.code
                ) {
                    let sessionExpirable = that.isSessionExpirable();
                    if (!sessionExpirable) {
                        if (done) done();
                        return;
                    }

                    that.logOut();
                    if (done) done();
                    return;
                }

                if (data.data && data.data.session) that.saveSessionData(data.data.session, true);

                if (done) done();
            })
            .catch((er) => {
                console.log('ant-log-er=', er);
                if (done) done();
            });
    },

    async refreshToken(reload, that, done, onChanged, forceFullSnapshot) {
        if (!that) that = this;

        var URL = '/user/ACUserAuthen/refreshToken';

        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        let info = localStorage.getItem(cs.System_Code + '-session-info');
        if (!info) {
            this.logOut();
            return;
        }

        info = JSON.parse(info);
        const snapshotState = that.getSessionSnapshotState();
        const snapshotRequest = createSessionSnapshotRequest(info, snapshotState, {
            forceFull: Boolean(reload || forceFullSnapshot)
        });

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
            'Business-Short-Code': info.business_short_code,
            'Business-Zone-Code': info.business_zone_code,
            'Business-Industry': info.business_industry,
            'Business-Sub-Industry': info.business_sub_industry,
            ...resolveServiceRoutingHeaders(info)
        };

        const deviceId = await this.getDeviceID();

        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(
                stringify({
                    app_id: info.app_id,
                    device_id: deviceId,

                    viewMode: this.getViewMode(),
                    timezone: moment.tz.guess(),
                    ...snapshotRequest
                })
            ),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                if (
                    data?.code == cs.erAuthenticationFailed.code ||
                    data?.code == cs.erAccountIsLocked.code ||
                    data?.code == cs.erLoggedInOtherDevice.code
                ) {
                    let sessionExpirable = that.isSessionExpirable();
                    if (sessionExpirable) {
                        // if (!sessionExpirable && data?.code == cs.erAuthenticationFailed.code) {
                        //     if (data.data && data.data.session) that.saveSessionData(data.data.session, reload, onChanged);
                        //     if (done) done();
                        //     return;
                        // }

                        console.log('ant-log-LOGOUT-RefreshToken : ');
                        that.logOut();
                        if (done) done();
                        return;
                    }
                }

                if (data && data.data && data.data.session) {
                    const resolved = applySessionSnapshot(info, snapshotState, data.data.session);
                    if (!resolved) {
                        if (!forceFullSnapshot && snapshotRequest.knownSnapshotRevision)
                            return that.refreshToken(reload, that, done, onChanged, true);
                        if (done) done();
                        return;
                    }
                    data.data.session = resolved.session;
                    if (resolved.infoChanged || !that.saveRefreshedSessionTokens(resolved.session))
                        that.saveSessionData(resolved.session, reload, onChanged, true);
                    that.saveSessionSnapshotState(resolved.state);
                }

                if (done) done();
            })
            .catch((er) => {
                console.log('ant-log-er=', er);
                if (done) done();
            });
    },

    // ===== Helpers cho cluster Cash Shift / Lock Screen (Task 18) =====

    // Lấy business setting theo key. Trả về undefined nếu không tồn tại.
    getBusSetting(key) {
        var settings = this.getSessionInfo('bus_settings') || {};
        return settings[key];
    },

    // Lấy user setting theo key. Trả về undefined nếu không tồn tại.
    getUserSetting(key) {
        var settings = this.getSessionInfo('user_settings') || {};
        return settings[key];
    },

    // Wrapper gọi API tuỳ ý có Authorization + business headers (giống pattern checkin/checkout).
    callApi(URL, body, cb) {
        var that = this;
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

        // URL có thể truyền dạng 'user/ACUserAuthen/x' (không có '/' đầu) hoặc '/user/...'
        var path = String(URL || '');
        if (path && path.charAt(0) !== '/') path = '/' + path;
        var queryURL = AntString.clean(BaseURL + path);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        let info = localStorage.getItem(cs.System_Code + '-session-info');
        try {
            info = JSON.parse(info) || {};
        } catch (e) {
            info = {};
        }

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + token,
            'Business-Short-Code': info.business_short_code,
            'Business-Zone-Code': info.business_zone_code,
            'Business-Industry': info.business_industry,
            'Business-Sub-Industry': info.business_sub_industry,
            ...resolveServiceRoutingHeaders(info)
        };

        fetch(queryURL, {
            method: 'POST',
            body: AntString.clean(stringify(body || {})),
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                that.verifyResponse(data);
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    },

    // Verify mã PIN — dùng cho luồng switch nhân viên tại quầy POS.
    // Trả { matched_employee_code, matched_employee_name, switched } khi đúng.
    verifyPasscode(passCode, cb) {
        return this.callApi('/user/ACUserAuthen/verifyPasscode', { pass_code: passCode }, cb);
    },

    // Khoá phiên — phát event để AntLockScreen hiển thị overlay.
    lockSession() {
        try {
            window.dispatchEvent(new Event('apt-lock-now'));
        } catch (e) {
            // ignore
        }
    },

    // Mở khoá phiên — verify PIN của user hiện tại (KHÔNG liên quan switch nhân viên).
    // cb({ data: { unlocked: true } }) khi đúng, cb({ error }) khi sai.
    unlockSession(passCode, cb) {
        return this.callApi('/user/ACUserAuthen/unlockSession', { pass_code: passCode }, cb);
    },

    // Đổi PIN — STRICT: payload phải có target='user'|'employee'.
    // payload: { target, old_pass_code, new_pass_code }.
    // BE verify old_pass_code đối với target tương ứng (ACUserAccount hoặc ACUserEmployee).
    changePasscode(payload, cb) {
        return this.callApi('/user/ACUserAuthen/changePasscode', payload || {}, cb);
    },

    // Verify PIN cũ ngay tại STEP_OLD của popup đổi PIN — không update DB.
    // payload: { target: 'user'|'employee', pass_code }.
    verifyOldPasscode(payload, cb) {
        return this.callApi('/user/ACUserAuthen/verifyOldPasscode', payload || {}, cb);
    },

    // PIN-based checkin (Vào ca / Đổi ca) — bước 1: lookup nhân viên theo PIN.
    prepareCheckinByPin(passCode, cb) {
        return this.callApi('/user/ACUserAuthen/prepareCheckinByPin', { pass_code: passCode }, cb);
    },

    // PIN-based checkin — bước 2: confirm + actual_amt. Tự auto-checkout ca cũ nếu có.
    // BE trả về session mới (giống actionRefreshToken) → PHẢI saveSessionData để FE dùng token mới
    // (employee_code, employee_session_status, shift_id mới). Truyền reload=false để caller tự
    // quyết định reload — nếu để saveSessionData reload luôn sẽ chạy 2 lần khi lock screen cũng reload.
    verifyCheckinByPin(passCode, actualAmt, cb) {
        var that = this;
        return this.callApi('/user/ACUserAuthen/verifyCheckinByPin', { pass_code: passCode, actual_amt: actualAmt }, (data) => {
            if (data && data.data && data.data.session) that.saveSessionData(data.data.session, false);
            if (cb) cb(data);
        });
    },

    // PIN-based checkout (Cắt ca) — bước 1: verify PIN + lấy thông tin tổng kết ca.
    prepareCheckoutByPin(passCode, cb) {
        return this.callApi('/user/ACUserAuthen/prepareCheckoutByPin', { pass_code: passCode }, cb);
    },

    // PIN-based checkout — bước 2: confirm + actual_amt. BE trả session mới (đã clear employee_*) → saveSessionData.
    verifyCheckoutByPin(passCode, actualAmt, cb) {
        var that = this;
        return this.callApi('/user/ACUserAuthen/verifyCheckoutByPin', { pass_code: passCode, actual_amt: actualAmt }, (data) => {
            if (data && data.data && data.data.session) that.saveSessionData(data.data.session, false);
            if (cb) cb(data);
        });
    }
};
